import React, { useEffect, useRef } from 'react';
import needle from "../../icons/wired-outline-951-customer-management-hover-roll.json";
import work from "../../icons/wired-outline-969-meeting-conference-room-hover-pinch.json";
import laser from "../../icons/wired-outline-3138-customer-insights-alt-hover-pinch.json";
import free from "../../icons/wired-outline-1007-organization-hover-pinch.json";
import styles from './BenefitHishtalmut.module.css';
import ScrollReveal from 'scrollreveal';
import { Player } from "@lordicon/react";

const VerticalIconCard = ({ text, icon }) => {
  const playerRef1 = useRef(null);

  const handleComplete = () => {
    setTimeout(() => {
      playerRef1?.current?.playFromBeginning();
    }, 2500);
  };

  useEffect(() => {
    playerRef1?.current?.playFromBeginning();
  }, []);

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.text}`, {
      duration: 1000,
      distance: "40px",
      origin: "bottom",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.icon}>
        <Player
          icon={icon}
          ref={playerRef1}
          size="100%"
          onComplete={handleComplete}
        />
      </div>
      <p className={styles.text}>{text}</p>
    </div>
  );
};

const BenefitsContainer = () => {
  const benefits = [
    {
      icon: needle,
      text: "כמה שוות לך 3 שעות שנחסכות ממך כל יום?"
    },
    {
      icon: work,
      text: "כמה שווה לך לא להתעסק בגבייה ובחיזור אחרי לידים שלא עונים"
    },
    {
      icon: laser,
      text:"כמה שווה לך שיגייסו את העובדים הבאים שלך עבורך"
    },
    {
      icon: free,
      text:"כמה שווה לך להיות בפוקוס אמיתי על העסק שלך מעכשיו והלאה?"
    }
  ];

  return (
    <div className={styles.container}>
      {benefits.map((benefit, index) => (
        <VerticalIconCard
          key={index}
          text={benefit.text}
          icon={benefit.icon}
        />
      ))}
    </div>
  );
};

export default VerticalIconCard;
export { BenefitsContainer };